import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";

const FALLBACK_THUMB = "/assets/icons/video-icon.svg";

@Component({
  selector: "evrideo-mam-explorer-name-cell",
  template: `<img
      [src]="thumb"
      width="48px"
      [style.object-fit]="'scale-down'"
      [title]="name || 'thumbnail'"
      (error)="onImgError()"
    /><span *ngIf="name" [title]="name">{{ name }}</span>`,
  styleUrls: ["./mam-explorer-name-cell.component.scss"],
})
export class MamExplorerNameCellComponent implements ICellRendererAngularComp {
  name!: string;
  thumb!: string;
  objectFitNone: boolean = false;

  agInit(params: ICellRendererParams): void {
    this.updateDisplayValue(params);
  }

  refresh(params: ICellRendererParams): boolean {
    this.updateDisplayValue(params);
    return true;
  }

  onImgError(): void {
    this.thumb = FALLBACK_THUMB;
  }

  private updateDisplayValue(params: any): void {
    if (!params.data) {
      return;
    }
    this.thumb = params.videoThumb(params.data);
    this.name = params.videoName(params.data);
    if (!this.thumb) {
      this.thumb = FALLBACK_THUMB;
      this.objectFitNone = true;
    }
  }
}
